import { useEffect, useState } from "react";
import { getCompany } from "../../../redux/actions/company";
import { useDispatch } from "react-redux";
import { Image } from "semantic-ui-react";
import logo from "../../../images/logos/full_logo_black.svg";

const CompanyHeader = ({ companyId }) => {
  const dispatch = useDispatch();
  const [company, setCompany] = useState(null);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { payload } = await dispatch(getCompany(companyId));
        setCompany(payload.data);
      } catch (error) {
        console.error("Error fetching company:", error);
      }
    };

    if (companyId) {
      fetchCompany();
    }
  }, [companyId]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // <-- This centers the content horizontally
        gap: "12px",
        width: "100%",
      }}
    >
      <Image
        src={company?.logo_url || "https://via.placeholder.com/150"}
        alt={company?.name || "Company Logo"}
        size="small"
      />
      <span style={{ fontSize: "24px", fontWeight: "bold" }}>×</span>
      <Image src={logo} alt="Full Logo" size="small" />
    </div>
  );
};

export default CompanyHeader;